export default {
  opacity_level_semisolid: '0.8',
  opacity_level_intense: '0.64',
  opacity_level_medium: '0.32',
  opacity_level_light: '0.16',
  opacity_level_semitransparent: '0.08',
}
